import {useTranslation} from "react-i18next";
import React from "react";

const GoalTargetBlock = ({ goal, target }: { goal?: any, target?: any }) => {
    const { t} = useTranslation()

    return (
        <div className="goal-target-block">
            <div className="goal-target-row">
                <div className="goal-target-card">
                    <div className="goal-target-title">{t('yourGoal')}</div>
                    <div className="goal-target-value">
                        <span role="img" aria-label="goal">{target?.emoji || '👑'}</span> <b>{target?.optionValue || 'Target'}</b>
                    </div>
                </div>
                <div className="goal-target-card">
                    <div className="goal-target-title">{t('yourTarget')}</div>
                    <div className="goal-target-value"><span role="img" aria-label="vacation">{goal?.emoji || '💪'}</span> <b>{goal?.optionValue || 'Goal'}</b></div>
                </div>
            </div>
        </div>
    );
};
export default GoalTargetBlock;
